import logo from './logo.svg';
import './App.css';
import TypingTest from './pages/TypingTest';

function App() {
  return (
    <div className="App">
      <TypingTest />
    </div>
  );
}

export default App;
